import {
  setPclientState,
  getClientsData,
  uploadClientsData,
  adoptClient,
  getAdoptClients,
  updataPclientMajor,
  getRecpClients,
  getMyClients,
  updataClientTag,
  newClientDetail,
  updataClientDetail,
  getMyClientCalendar,
  newReturnVisit,
  getMyReturnVisitList,
  getClientPayUrl,
  getClientRechargeList,
  getClientDetail,
  newRechargeRefund,
  getPotentialClientsSchool,
  searchPotentialClientsHistory,
  newClientReceived,
  updateReturnVisit
} from '@/api/client'

const state = {};

const mutations = {};

const actions = {
  newclientreceived({commit}, data) {
    return new Promise((resolve, reject) => {
      newClientReceived(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  updatereturnvisit({commit}, data) {
    return new Promise((resolve, reject) => {
      updateReturnVisit(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  searchpotentialclientshistory({commit}, data) {
    return new Promise((resolve, reject) => {
      searchPotentialClientsHistory(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getpotentialclientsschool({commit}, data) {
    return new Promise((resolve, reject) => {
      getPotentialClientsSchool(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newrechargerefund({commit}, data) {
    return new Promise((resolve, reject) => {
      newRechargeRefund(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getclientdetail({commit}, data) {
    return new Promise((resolve, reject) => {
      getClientDetail(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getclientrechargelist({commit}, data) {
    return new Promise((resolve, reject) => {
      getClientRechargeList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getclientpaymenturl({commit}, data) {
    return new Promise((resolve, reject) => {
      getClientPayUrl(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getmyreturnvisitlist({commit}, data) {
    return new Promise((resolve, reject) => {
      getMyReturnVisitList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newreturnvisit({commit}, data) {
    return new Promise((resolve, reject) => {
      newReturnVisit(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getmyclientcalendar({commit}, data) {
    return new Promise((resolve, reject) => {
      getMyClientCalendar(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updataclientdetail({commit}, data) {
    return new Promise((resolve, reject) => {
      updataClientDetail(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newclientdetail({commit}, data) {
    return new Promise((resolve, reject) => {
      newClientDetail(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updataclienttag({commit}, data) {
    return new Promise((resolve, reject) => {
      updataClientTag(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getmyclients({commit}, data) {
    return new Promise((resolve, reject) => {
      getMyClients(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getrecpclients({commit}, data) {
    return new Promise((resolve, reject) => {
      getRecpClients(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setpclientstate({commit}, data) {
    return new Promise((resolve, reject) => {
      setPclientState(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getadoptclients({commit}, params) {
    return new Promise((resolve, reject) => {
      getAdoptClients(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  adoptclient({commit}, data) {
    return new Promise((resolve, reject) => {
      adoptClient(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  uploadclientsdata({commit}, data) {
    return new Promise((resolve, reject) => {
      uploadClientsData(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getclientsdata({commit}, data) {
    return new Promise((resolve, reject) => {
      getClientsData(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatapclientmajor({commit}, data) {
    return new Promise((resolve, reject) => {
      updataPclientMajor(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
